<template>
  <div @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <main>
      <div id="container">
        <div id="content">
          <div class="title">
            <h2>mm/styleとは</h2>
          </div>
          <section>
            <h3>mm/style (ミリスタイル)とは？</h3>
            <p>mm/styleとは、お客様の必要な家具のサイズとスタイルを入力するだけでそのまま注文ができる、デジタルカタログです。<br>
              「mm/style」の最大の特徴は、お客様自身が1mm単位で寸法を入力し、そのまま注文できることです。出力されるデータは、国内外で特許を取得した独自のシステムにより全て自動生成、工場の機械に直結します。<br>
              人手や手間を無くすことでオーダー家具でありながら低価格かつ短納期を実現した、家具の常識を覆すカタログです。</p>
            <img :src="getImage('what/desktop_order.png')" alt="商品画面" width="660px" height="auto"> </section>
          <section>
            <h3>3つのPOINT</h3>
            <ul  class="point_li bold">
              <li>①現場にあわせて<span class="red">WHDの3サイズがオーダー</span>できる！</li>
              <li>②オーダーなのに<span class="red">低価格＆短納期</span>!!</li>
              <li>③図面も見積りもその場で確認！<span class="red">そのまま注文</span>!!</li>
            </ul>
            <p>世界唯一のオーダー家具製造システムによって低価格＆短納期でお届けすることが可能です！</p>
          </section>
          <section>
            <h3>ご注文の流れ</h3>
            <img :src="getImage('what/aboutmmstyle.svg')" alt="ご注文の流れ" width="660px" height="auto">
          </section>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import * as App from '../../utils/App'
import Header from '../components/common/DcHeader'

export default {
  name: 'what',
  components: {
    'dd-header': Header
  },
  data () {
    return {
    }
  },
  methods: {
    closeMenu: function () {
      this.$refs.menuRef.close()
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style src="../css/what.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/WhatMmStyle.vue